import _ from 'lodash';
import React, { PureComponent } from 'react';

import { trackAnalyticsEvent } from '@eb/site-analytics';
import transform from '../transform';
import defaultSettings from './settings';
import userSettings from './userSettings';

import {
    PACKAGE_ONE,
    PACKAGE_ONE_PAGE,
    PACKAGE_ONE_PATH,
    PACKAGE_PATHS,
} from '../../constants/main';
import PageTitle from '../../components/PageTitle';
import FeaturesExpansion from '../../components/FeaturesExpansion';
import Testimonials from '../../components/Testimonials';
import MainHeader from '../../components/MainHeader';
import ThreeColumnFeatures from '../../components/ThreeColumnFeatures';
import TwoColumnFeatures from '../../components/TwoColumnFeatures';
import BorderBanner from '../../components/BorderBanner';
import ActionBanner from '../../components/ActionBanner';
import {
    ESSENTIALS_CTA_ACTION,
    ESSENTIALS_STICKY_CTA_ACTION,
    ESSENTIALS_UPSELL_CTA_ACTION,
    GA_BOTTOM_LABEL,
    GA_CHOOSE_PACKAGE,
    GA_LEARN_MORE_CLICKED,
    GA_P2_LABEL,
    GA_P3_LABEL,
    GA_TOP_LABEL,
    PACKAGE_NAVIGATION_ACTION,
} from '../../constants/analytics';
import { loadCrazyEgg } from '../utils';

const UpsellBanner = (bannerProps) => (
    <div className="eds-g-grid eds-l-sn-pad-top-0 eds-l-sm-pad-top-0 eds-l-sw-pad-top-0 eds-l-mn-pad-top-0 eds-l-pad-top-6 eds-l-pad-bot-12">
        <div className="eds-g-group">
            <div className="eds-g-cell eds-g-offset-1-12 eds-g-cell-10-12 upsell-border eds-text-color--ui-orange">
                <BorderBanner {...bannerProps} />
            </div>
        </div>
    </div>
);

export default class PackageOnePage extends PureComponent {
    componentDidMount() {
        loadCrazyEgg();
    }

    render() {
        const {
            activeScopeUserId,
            locale,
            isAuthenticated,
            assortmentsPricing,
            assortmentsTax,
            goToPricing,
            goToPackageTwo,
            goToPackageThree,
            goToPackageComparison,
            redirectToEssentials,
            userPlan,
            packageTitles,
            showLowAtvUi,
        } = this.props;
        const tabActions = [
            _.noop,
            goToPackageTwo.bind(null, PACKAGE_NAVIGATION_ACTION, GA_P2_LABEL),
            goToPackageThree.bind(null, PACKAGE_NAVIGATION_ACTION, GA_P3_LABEL),
        ];
        const {
            bottomBanner,
            upsellBanner,
            featureListOne,
            featureListTwo,
            featureListThree,
            testimonials,
            featuresExpansion,
            mainHeader,
        } = transform({
            locale,
            isAuthenticated,
            defaultSettings,
            page: PACKAGE_ONE_PAGE,
            userSettings,
            userPlan,
        });

        trackAnalyticsEvent({
            action: GA_LEARN_MORE_CLICKED,
            category: GA_CHOOSE_PACKAGE,
            dimensions: {
                userId: activeScopeUserId,
                planLearnMore: PACKAGE_ONE_PATH,
                locale,
            },
        });

        return (
            <div>
                <PageTitle title={packageTitles.essentials} />
                <MainHeader
                    {...mainHeader}
                    price={assortmentsPricing[PACKAGE_ONE]}
                    taxLabel={assortmentsTax[PACKAGE_ONE]}
                    tabActions={tabActions}
                    tabPaths={PACKAGE_PATHS}
                    hidePricing={showLowAtvUi}
                    onClick={redirectToEssentials.bind(
                        null,
                        ESSENTIALS_CTA_ACTION,
                        GA_TOP_LABEL,
                    )}
                    onStickyClick={redirectToEssentials.bind(
                        null,
                        ESSENTIALS_STICKY_CTA_ACTION,
                    )}
                    pricingCalloutAction={goToPricing.bind(
                        null,
                        null,
                        PACKAGE_ONE,
                    )}
                />
                <ThreeColumnFeatures
                    {...featureListOne}
                    removeHorizontalPadding={true}
                />
                <TwoColumnFeatures {...featureListTwo} />
                <TwoColumnFeatures
                    {...featureListThree}
                    reverseHorizontal={true}
                />
                <UpsellBanner
                    {...upsellBanner}
                    onClick={goToPackageTwo.bind(
                        null,
                        ESSENTIALS_UPSELL_CTA_ACTION,
                    )}
                />
                <Testimonials {...testimonials} />
                <FeaturesExpansion
                    {...featuresExpansion}
                    onClick={goToPackageComparison.bind(null, PACKAGE_ONE)}
                />
                <ActionBanner
                    {...bottomBanner}
                    onClick={redirectToEssentials.bind(
                        null,
                        ESSENTIALS_CTA_ACTION,
                        GA_BOTTOM_LABEL,
                    )}
                />
            </div>
        );
    }
}
